import { Card, CardContent, List, ListItem, ListItemText, Typography } from "@mui/material";
import { DataGrid, DataGridPro } from "@mui/x-data-grid-pro";
import { snakeCaseToCapitalizedWords } from "utils/globalsUtils";

export const AISimulationInsights = ({ insights }: { insights: any[] }) => {
  if (!insights || insights.length === 0) {
    return (
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant="subtitle1">No insights available.</Typography>
        </CardContent>
      </Card>
    );
  }
  return (
    <DataGridPro
      rows={Object.entries(insights).map(([key, value]) => ({
        id: key,
        key: snakeCaseToCapitalizedWords(key),
        value
      }))}
      columns={[
        { field: 'key', headerName: 'Key', flex: 1 },
        { field: 'value', headerName: 'Value', flex: 2 },
      ]}
    />
  );
}; 